import { render, staticRenderFns } from "./PageGroups.vue?vue&type=template&id=7be98b91&"
import script from "./PageGroups.vue?vue&type=script&lang=ts&"
export * from "./PageGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports